.slider {
  width: 100%;
}

.stats {
  width: calc(100% - 40px);
  max-width: 335px;
  margin: 0 auto 24px;
  color: #221e1a;
  text-align: center;
}

.metric {
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: clamp(44px, 13vw, 50px);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.15px;
}

.subtitle {
  margin-top: 2px;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 17px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.068px;
}

.viewport {
  overflow-x: auto;
  padding-left: 20px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scroll-padding-left: 20px;
  padding-bottom: 10px;
}

.viewport::-webkit-scrollbar {
  display: none;
}

.track {
  display: flex;
  gap: 8px;
  width: max-content;
  padding-right: 20px;
}

.card {
  --review-accent: var(--ed-brand, #ae66f6);
  flex: 0 0 min(335px, calc(100vw - 40px));
  min-height: 186px;
  padding: 24px 24px 20px;
  border: 1.5px solid var(--ed-border, var(--review-accent));
  border-radius: 32px;
  background: #f2ede1;
  box-shadow: 3px 5px 0 0 var(--review-accent);
  scroll-snap-align: start;
  box-sizing: border-box;
}

.cardInner {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  width: 100%;
}

.person {
  width: 90px;
  min-width: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.avatar {
  width: 90px;
  height: 90px;
  border-radius: 999px;
  object-fit: cover;
  display: block;
}

.name {
  width: 100%;
  color: #221e1a;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.036px;
}

.content {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stars {
  width: 120px;
  height: auto;
  display: block;
}

.quote {
  color: #221e1a;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.045px;
}

@media (max-width: 359px) {
  .card {
    flex-basis: calc(100vw - 52px);
    padding: 20px;
  }

  .cardInner {
    gap: 16px;
  }

  .person {
    width: 76px;
    min-width: 76px;
  }

  .avatar {
    width: 76px;
    height: 76px;
  }

  .quote {
    font-size: 14px;
    line-height: 19px;
  }
}
